<template>
    <CommonError :data="props.data" @logout="logout" @btn-click="btnClick"></CommonError>
</template>

<script setup>
import { CommonError } from '@yanxiu/error';
import { useStore } from 'vuex';
import { pageJump } from '@/global/location-transfer';


const store = useStore();

const props = defineProps({
    data: {
        type: Object,
        default: () => {
            return {
                // code: 0,
                // title: '',
                // message: '页面出错了~',
                // buttonLabel: '返回首页',
                // target: '/idx/home',
                // isClearCookie: false
            };
        }
    }
})

function logout() {
    console.log('logout', 222)
    store.dispatch('logout');
}

function btnClick(target) { // 默认走首页
    if (props.data.isClearCookie) {
        store.dispatch('removeCookies');
    }
    pageJump(target);
}

</script>

<style lang="scss" scoped>

</style>
